    var pwaQuery = window.matchMedia("all and (display-mode: standalone)");
        
    if (pwaQuery.matches) { 
        if (window.history.length <= 1) {
            document.documentElement.classList.add('no-last-page');   
        }
    }